// extracted by mini-css-extract-plugin
module.exports = {"container":"SelectStarterBoxSection_container__cAAVY","title":"SelectStarterBoxSection_title___7xOA"};